<template>
  <div>
    <gs-modal
      v-model="visible"
      :title="'用户组-'+form.groupName"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :has-form="true"
      class="group-dialog"
      width="50%"
      top="10%"
      @cancel="close"
      @close="close"
      @confirm="handleConfirm"
    >
      <gs-tabs
        v-model="activeName"
        type="content-tab"
      >
        <gs-tab-pane
          label="用户组"
          name="userGroup"
          icon="star"
        >
          <div class="page-form">
            <gs-form
              ref="form"
              :model="form"
              class="form"
              label-width="60px"
              label-position="left"
              gap="small"
            >
              <div class="general">
                <div class="title">概述</div>
                <gs-form-item
                  label="用户组名:"
                  prop="groupName"
                  class="form-item-groupName"
                >
                  <gs-input
                    ref="nameInput"
                    v-model="form.groupName"
                    type="text"
                  />
                </gs-form-item>
                <gs-form-item
                  label="描述"
                  prop="description"
                  class="form-item-description"
                >
                  <gs-input
                    v-model="form.description"
                    type="text"
                  />
                </gs-form-item>

                <gs-form-item
                  label="用户"
                  prop="users"
                >
                  <gs-input
                    ref="usersInput"
                    v-model="showUsers"
                    @focus="openUserList()"
                  />
                </gs-form-item>

                <!-- <gs-form-item
                  label="用户配置"
                  prop="userProfile"
                  class="form-item-userProfile"
                >
                  <gs-input
                    v-model="form.userProfile"
                    type="text"
                    placeholder="请输入用户配置"
                  />
                </gs-form-item> -->
              </div>
              <div class="automaticLogout">
                <div class="title">自动注销</div>
                <gs-form-item
                  label="注销时间（分）"
                  prop="logoutTime"
                  class="form-item-logoutTime"
                >
                  <gs-input
                    v-model="form.logoutTime"
                    type="number"
                    placeholder="请输入注销时间"
                  />
                </gs-form-item>

                <!-- <gs-form-item
                  label="待机时间（分）"
                  prop="standbyTime"
                  class="form-item-standbyTime"
                >
                  <gs-input
                    v-model="form.standbyTime"
                    type="number"
                    placeholder="请输入待机时间"
                  />
                </gs-form-item> -->
              </div>
            </gs-form>
          </div>
        </gs-tab-pane>
      </gs-tabs>
    </gs-modal>
    <gs-modal
      v-model="visibleUserList"
      :before-close="beforeCloseUserList"
      :before-confirm="beforeConfirmUserList"
      :has-form="true"
      width="30%"
      class="userList-dialog"
      title="用户列表"
      @close="closeUserList"
      @cancel="closeUserList"
      @confirm="handleConfirmUserList"
    >
      <div class="userList-dialog-body">
        <gs-table
          :data="form.users"
          :height="300"
          style="width:100%"
          @row-dblclick="openDetail"
          @select="getSelection"
          @select-all="getSelection"
        >
          <gs-table-column
            :show-overflow-tooltip="true"
            type="selection"
          />
          <gs-table-column
            :show-overflow-tooltip="true"
            prop="name"
            label="用户名"
          />
          <gs-table-column
            :show-overflow-tooltip="true"
            :formatter="typeFormatter"
            prop="type"
            label="类型"
          />
        </gs-table>
      </div>
      <div class="userList-dialog-footer">
        <gs-button @click="addUser">增加</gs-button>
        <gs-button @click="openDetail">属性</gs-button>
        <gs-button @click="delUser">删除</gs-button>
      </div>
    </gs-modal>
    <gs-modal
      v-model="visibleUserSelect"
      :before-close="beforeCloseUserSelect"
      :has-form="true"
      class="select-dialog"
      title="添加用户"
      width="30%"
      @cancel="closeUserSelect"
      @confirm="handleConfirmUserSelect"
    >
      <div class="select-dialog-body">
        <gs-table
          v-if="visibleUserSelect"
          ref="selectTable"
          :data="dataList"
          :height="300"
          style="width:100%"
          @select="getAddSelection"
          @select-all="getAddSelection"
        >
          <gs-table-column
            :show-overflow-tooltip="true"
            type="selection"
          />
          <gs-table-column
            :show-overflow-tooltip="true"
            prop="name"
            label="名称"
          />
          <gs-table-column
            :show-overflow-tooltip="true"
            :formatter="typeFormatter"
            prop="type"
            label="类型"
          />
        </gs-table>
      </div>
    </gs-modal>
  </div>
</template>
<script>
import service from '../../service/authorityService.js'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  data() {
    return {
      visibleUserList: false,
      visibleUserSelect: false,
      dataList: [],
      activeName: 'userGroup',
      addSelection: [],
      selection: [],
      form: {
        groupId: '',
        groupName: '',
        description: '',
        logoutTime: '',
        users: [],
        userProfile: '',
        standbyTime: ''
      },
      startUsers: [], // 修改前的用户列表
      upserts: {
        users: [] // 修改后增加的用户列表
      },
      dels: {
        users: [] // 修改后删除的用户列表
      }
    }
  },
  computed: {
    ...mapState({
      visible: 'groupShow',
      objectData: 'objectInfo'
    }),
    // 输入框展示用户列表
    showUsers: function () {
      var str = ''
      var array = this.form.users
      array.forEach(function (value, index, array) {
        if (index === array.length - 1) {
          str += value.username
        } else {
          str += value.username + ','
        }
      })
      return str
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        service.getGroupDetail(this.objectData.groupId).then(res => {
          res.users.forEach((value, index, array) => {
            value.type = 'user'
            value.name = value.username
          })
          this.form = res
          this.startUsers = [...res.users] // 复制数组:将修改前的用户列表保存起来
        })
      }
    }
  },
  methods: {
    ...mapMutations({
      close: 'GROUP_HIDE',
      showListDialog: 'LIST_DIALOG_SHOW',
      needReload: 'NEED_RELOAD_TREE',
      userShow: 'USER_SHOW'
    }),
    typeFormatter(row, column) {
      return '用户'
    },
    handleConfirm() {
      this.upserts.users = []
      this.dels.users = []
      if (this.startUsers === null || this.startUsers.length === 0) {
        this.form.users.forEach((value, index, array) => {
          this.upserts.users.push({ 'userId': value.userId })
        })
      } else {
        // 对比修改后和修改前的用户列表,如果在修改前列表里面找不到的用户即添加到upserts.users数组中
        for (let i = 0; i < this.form.users.length; i++) {
          let flag = false
          for (let j = 0; j < this.startUsers.length; j++) {
            if (this.form.users[i].userId === this.startUsers[j].userId) {
              flag = true
              break
            }
          }
          if (!flag) {
            this.upserts.users.push({ 'userId': this.form.users[i].userId })
          }
        }
        // 对比修改前和修改后的用户列表,如果在修改后列表里面找不到的用户即添加到dels.users数组中
        for (let i = 0; i < this.startUsers.length; i++) {
          let flag = false
          for (let j = 0; j < this.form.users.length; j++) {
            if (this.startUsers[i].userId === this.form.users[j].userId) {
              flag = true
              break
            }
          }
          if (!flag) {
            this.dels.users.push({ 'userId': this.startUsers[i].userId })
          }
        }
      }
      let params = {
        groupName: this.form.groupName,
        description: this.form.description,
        logoutTime: this.form.logoutTime,
        upserts: this.upserts,
        dels: this.dels
      }
      service.updateGroup(this.form.groupId, params).then(res => {
        this.$Message.success('修改用户组成功!')
        this.close()
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    beforeConfirm(e, done) {
      // done(false)可以阻止modal关闭
      done()
    },
    beforeClose(e, done) {
      // done(false)可以阻止modal关闭
      this.close()
    },
    openUserList() {
      this.$refs.usersInput.blur()
      this.visibleUserList = true
    },
    beforeCloseUserList() {
      this.visibleUserList = false
      this.disabled = false
    },
    closeUserList() {
      this.visibleUserList = false
      this.disabled = false
    },
    beforeConfirmUserList() {
      this.visibleUserList = false
      this.disabled = false
    },
    handleConfirmUserList() {
      this.visibleUserList = false
      this.disabled = false
    },
    getAddSelection(selection, row) {
      this.addSelection = selection
    },
    getSelection(selection, row) {
      this.selection = selection
    },
    openDetail(row, event) {
      if (event) {
        this.$store.state.objectInfo = row
      } else {
        if (this.selection.length !== 1) {
          this.$Message.warning('只能勾选一项')
          return
        }
        this.$store.state.objectInfo = this.selection[0]
      }
      this.userShow()
    },
    addUser() {
      let _this = this
      this.visibleUserSelect = true
      this.addSelection = []
      service.getUserList().then(res => {
        res.forEach((value, index, array) => {
          value.name = value.username
          value.type = 'user'
        })
        this.dataList = res
        if (this.form.users !== null && this.form.users.length > 0) {
          setTimeout(() => {
            this.dataList.forEach(value => {
              let flag = _this.form.users.some(res => {
                return value.userId === res.userId
              })
              if (flag) {
                _this.$refs.selectTable.toggleRowSelection(value, true)
              }
            })
          }, 0)
        }
      })
    },
    delUser() {
      if (this.selection === null || this.selection.length === 0) {
        this.$Message.warning('请至少选择一项')
        return
      }
      this.selection.forEach((value, index, array) => {
        this.form.users = this.form.users.filter(e => {
          return e.userId !== value.userId
        })
      })
    },
    beforeCloseUserSelect() {
      this.visibleUserSelect = false
    },
    closeUserSelect() {
      this.visibleUserSelect = false
    },
    handleConfirmUserSelect() {
      let _this = this
      if (this.addSelection != null) {
        this.addSelection.forEach(e => {
          _this.form.users.push(e)
        })
      }
      this.form.users = this.unique(this.form.users, 'userId')
      this.visibleUserSelect = false
    },
    unique(arr, name) {
      var hash = {}
      return arr.reduce(function (item, next) {
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
        return item
      }, [])
    }
  }
}
</script>
<style lang="scss" scoped>
.group-dialog {
  .page-form {
    .title {
      color: #0073e8;
      margin-bottom: 12px;
    }
    .gs-form-item {
      margin-bottom: 12px;
    }
    .button {
      float: right;
    }
  }
}
.userList-dialog {
  &-body {
    height: 340px;
    padding: 12px;
    border: solid 1px #d9d9d9;
    border-radius: 1px;
    overflow: auto;
    margin-bottom: 12px;
  }

  &-footer {
    text-align: center;
  }
}
.select-dialog {
  &-body {
    height: 340px;
    padding: 12px;
    border: solid 1px #d9d9d9;
    border-radius: 1px;
    overflow: auto;
    margin-bottom: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/authority/group.vue